import type { EntityType } from 'types/entityType';

import useTranslate from 'app/i18n/useTranslate';

import { ENTITY_PLURALS } from 'components/MultiSelectPanel/constants';

const useTranslation = () => {
    const t = useTranslate('multiSelectPanel');

    return {
        CHOOSE_MULTIPLE: (entityType?: EntityType) =>
            entityType
                ? t('chooseEntity', { entityType: ENTITY_PLURALS[entityType] })
                : t('chooseMultiple'),
        NO_ITEMS_FOUND: t('noItemsFound')
    };
};

export default useTranslation;
